import React from 'react';
import AttendanceCard from './AttendanceCard';

const AttendanceList = ({
  attendances,
  canManage,
  expandedId,
  toggleExpand,
  handleReopen,
  setDeleteTarget,
  loadingAttendees,
  attendees,
  statusLabels,
  t,
  formatDate,
  formatTime
}) => {
  if (attendances.length === 0) {
    return (
      <div className="noAttendancesText">
        <p>{t.noAttendances}</p>
      </div>
    );
  }

  return (
    <>
      {attendances.map((att) => (
        <AttendanceCard
          key={att.id}
          att={att}
          canManage={canManage}
          expandedId={expandedId}
          toggleExpand={toggleExpand}
          handleReopen={handleReopen}
          setDeleteTarget={setDeleteTarget}
          loadingAttendees={loadingAttendees}
          attendees={attendees}
          statusLabels={statusLabels}
          t={t}
          formatDate={formatDate}
          formatTime={formatTime}
        />
      ))}
    </>
  );
};

export default AttendanceList;
